import { FC, ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';
import { useIntl } from 'dibs-react-intl';
import { handleLocaleUrl } from 'dibs-intl/exports/urls';

import { SeoLink } from 'dibs-elements/exports/SeoLink';

import { PdpSharedPricingGuidanceSoldLink_item$key } from './__generated__/PdpSharedPricingGuidanceSoldLink_item.graphql';
import { LOCALE_US } from 'dibs-intl/exports/locales';

const itemFragment = graphql`
    fragment PdpSharedPricingGuidanceSoldLink_item on Item {
        serviceId
        isMultiSku
    }
`;

export const PdpSharedPricingGuidanceSoldLink: FC<{
    children: ReactNode;
    item: PdpSharedPricingGuidanceSoldLink_item$key;
    onClick?: () => void;
    skuId?: string | null;
}> = ({ children, item: itemRef, onClick = () => {}, skuId }) => {
    const intl = useIntl();

    const item = useFragment(itemFragment, itemRef);
    const { serviceId: itemPk, isMultiSku } = item;
    const showSimilarSoldLink = intl.locale === LOCALE_US;

    return showSimilarSoldLink ? (
        <SeoLink
            target="_blank"
            onClick={onClick}
            linkData={{
                path: handleLocaleUrl(
                    `/similar-sold/?item=${itemPk}${isMultiSku && skuId ? `#skuId=${skuId}` : ''}`,
                    intl.locale
                ),
            }}
        >
            {children}
        </SeoLink>
    ) : null;
};
